import { TOAST } from "@commoncore/constants/ToastMessages";
import { SessionStorageProps } from "@commoncore/enums/sessionStorageProps";
import { DcgroupcodePickerService } from "@commoncore/services/dcgroupcode-picker.service";
import { GlobalService } from "@commoncore/services/global.service";
import { LocalStorageSvc } from "@commoncore/services/localStorage.service";
import { AppEvents } from "@commoncore/utils/app-events";
import { MultiSelectLibrary } from "@commoncore/utils/MultiSelectUtil";
import { ENV_CONFIG } from "@env-properties/environment-config";

export class JioPhoneCallImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  static singleInstance: JioPhoneCallImplementation;
  localStorageSvc: LocalStorageSvc;
  customMetadata: any;
  jioPhoneCallAppFolderKey: String = null;
  jioPhoneCallAppCode: String = "jpc";
  jioPhoneCallObjects : any = [];
  multiSelect : any;
  sessionStorageService:any
  public currentPageNo = 0;
  public previousPageNo = -1;
  paginationService:any;
  public jioPhoneCallNextLink = ""
  public jioPhoneCallPreviousLink = "";
  containerHeightCalc: any;
  linkedAppFolderData:any = [];
  dcGroupCodePicker: any;

  constructor(public globalService: GlobalService) {
    this.setHandler(globalService);
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.paginationService = globalService.getPaginationServiceRef();
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  }

  public static getInstance(globalService): JioPhoneCallImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new JioPhoneCallImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  updateRecordingToggle(url, updateStatus) {
    var self = this;
    let isJioPhoneCallRecordingEnabled = updateStatus ? "Y" : "N"
    var params = {
      "isJpcAITabOn": isJioPhoneCallRecordingEnabled
    }
    return new Promise(function (resolve, reject) {
      self.http.put(url, params).subscribe(
        suc => {
          resolve(true)
        },
        err => {
          console.log('error in toggling  jpc AI Tab:', err);
          self.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
          reject(false);
        }
      )
    })
  }

  getAllLinkedApps(url) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        suc => {
          resolve(suc)
        },
        err => {
          console.log('error in get All LinkedApps:', err);
          self.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
          reject(false);
        }
      )
    })
  }

  getAllJioPhoneCallRecordingMetadata(url, isRoot: boolean) {
    var self = this;
    this.resetValuesOnFoldersListing();
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        async suc => {
          // suc["objects"] = [];
          self.paginationService.spliceAndSaveDataInLocalDB(suc["objects"]);
          self.setNextAndPreviousLinks(suc);
          let objList = await self.paginationService.getBufferDataForNextPage(self.currentPageNo);
          self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo);
          self.resetOnPageLoad(objList,isRoot);
          resolve(suc)
        },
        err =>  {
          if(err["error"]["code"] == 'NMSOM0062'){
            self.universalService.showToast(TOAST["FOLDER_KEY_INVALID"],"error");
            self.router.navigate(['/jpai']);
            self.universalService.showLoader = false;
            self.sessionStorageService.removeSessionProperty(SessionStorageProps.CURRENT_FOLDER_KEY);
          }else{
            self.universalService.showErrorMessage(err);
          }
          console.log('error in get AllJioPhoneCall Recording Metadata:',err);
          reject(false);
        }
      )
    })
  }

  getSMSLinkMetadata(url){
    var self = this;
    this.resetValuesOnFoldersListing();
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        async suc => {
          if(!suc){
            self.universalService.showToast(TOAST["JIOPHONE_CALL_AI_INVALID_SMS_KEY"],"error");
            self.router.navigate(["/jpai"]);
            resolve(true);
          }else{
            self.resetOnPageLoad(suc["objects"],false);
            resolve(suc)
          }
        },
        err =>  {
          self.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
          self.universalService.showErrorMessage(err);
          reject(false);
        }
      )
    })
  }

  async setDataAsPerView(objects) {
    var self = this;
    var allData = self.customMetadata.segregateData(objects, 'allfiles');
    allData.map(object => {
      if(object.objectType == "FE") {
        self.jioPhoneCallObjects.push(object);
      } else if(object.objectType == "FR") {
        self.universalService.showTopMenu = false;
        self.universalService.foldersArray.push(object);
      }
    })

    self.universalService.objectsPreviewArray = self.jioPhoneCallObjects;
    setTimeout(() => {
      AppEvents.virtualDOMObservable.next({ "updateVDOM": true })
    }, 10);
    this.universalService.showLoader = false;
    self.bindMultiSelect();
  }

  resetValuesOnFoldersListing() {
    let self = this;
    this.universalService.showTopMenu = false;
    this.universalService.showSortButtons = false;
    self.jioPhoneCallNextLink = "";
    self.jioPhoneCallPreviousLink = "";
    self.universalService.foldersArray = [];
    self.jioPhoneCallObjects = [];
    self.currentPageNo = 0;
    self.previousPageNo = -1;
    self.paginationService.LOCAL_DB = {};
    this.universalService.scrollToTopIcon = false;
    this.universalService.mobileSelectedObj = [];
    this.universalService.emptyFolder = false;
    self.universalService.objectsPreviewArray = [];
  }

  resetOnPageLoad(objects, isRoot) {
    if (objects && objects.length == 0) {
      this.universalService.showLoader = false;
      this.universalService.emptyFolder = true;
    }
    this.setDataAsPerView(objects);
    this.setHeightForView();
  }

  bindMultiSelect(){
    setTimeout(() => {
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      if(this.universalService.isMobileDevice) {
        this.multiSelect.bindMultiSelectLibrary("#jioPhoneCallFolderWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled);
        this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
      }else {
        this.multiSelect.bindMultiSelectLibrary("#jioPhoneCallFolderWrapperId", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled);
        this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
      }
      let allObjects = this.jioPhoneCallObjects.concat(this.universalService.foldersArray);
      AppEvents.multiSelectEvent.next({"dataArray":allObjects});
      AppEvents.virtualDOMObservable.next({"updateVDOM":true});
    }, 100);
  }

  async createUrlForNextLink(docheignt, toppos, url) {
      if (toppos == 0) {
        this.universalService.scrollToTopIcon = false;
      } else {        
        this.universalService.scrollToTopIcon = true;
        let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)
        
        if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
          this.previousPageNo = this.currentPageNo;
          setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
            this.currentPageNo ++;
            let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
            await this.appendData(objList);
            this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
          }, this.paginationService.bufferTimeoutForFetchingData);
        }
        if (checkIfContaineris95PercScrolled && this.jioPhoneCallNextLink != "" && this.jioPhoneCallPreviousLink != this.jioPhoneCallNextLink) {
          this.jioPhoneCallPreviousLink = this.jioPhoneCallNextLink;
          this.universalService.showLoader = true;
          this.getNextPageData(url);
        }
      }
    }
    
    getNextPageData(url) {
      this.http.get(url).subscribe(
        async nextPageData => {
          if(nextPageData["objects"] && !this.paginationService.LOCAL_DB[this.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
            let bufferDataPresent = this.paginationService.checkIfBufferDataIsPresent();
            if(!bufferDataPresent){
              this.currentPageNo = Object.keys(this.paginationService.LOCAL_DB).length;
              this.previousPageNo = this.currentPageNo - 1;
              this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
              this.setNextAndPreviousLinks(nextPageData);
              let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
              await this.appendData(objList);
              this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo);
              return;
            }
          }
          this.universalService.showLoader = false;
          this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
          this.setNextAndPreviousLinks(nextPageData);
        },
        err => {
          this.universalService.showErrorMessage(err);
        }
      )
    }
  
    async appendData(objectsList) {      
      this.setDataAsPerView(objectsList);
    }
    setNextAndPreviousLinks(suc){
      if (suc["nextLink"]) {
        this.jioPhoneCallNextLink = suc["nextLink"]        
      } else {
        this.jioPhoneCallNextLink = ""
      }
    }

    setHeightForView(){
      if(this.universalService.virtualGridEnabled && !this.universalService.isMobileDevice){
        return;
      }
      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      if (!this.universalService.isMobileDevice) {
        setTimeout(() => {
          this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'], 69);
        }, 500);
      }else{
        setTimeout(() => {
          this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],(79 + collapsedHeight));
        }, 500);
      }
    }

    getSMSLinkDC(dcGroupCodeURL){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(dcGroupCodeURL).subscribe(
            async suc=>{
              await self.dcGroupCodePicker.fetchShareMultiDcUrls(suc["shareDCCode"])
              resolve(suc["shareDCCode"].toLowerCase())
            },
            async err=>{
              await self.dcGroupCodePicker.fetchShareMultiDcUrls(ENV_CONFIG["constants"]["defaultDCGroupCode"]);
              reject(err)
            }
        )
      })
    }
  

}